<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row align-items-center" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle mb-0">Ad Images</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-center">
            <p class="adminName mb-0 mr-2">{{ adminName }}</p>
            <img width="36" height="36" style="margin-left:0.5em;" src="assets/tenant-avatar.jpg" class="rounded-circle" />
          </div>
        </div>

        <!-- Search + Add on same line -->
        <div class="row my-4 align-items-center">
          <div class="col-md-6 col-lg-7">
            <div class="search-wrapper">
              <i class="fa fa-search search-icon" aria-hidden="true"></i>

              <input
                type="text"
                class="search-input"
                placeholder="Search by country, category or name..."
                [(ngModel)]="searchval"
                (input)="onChangeEvent($event)"
                aria-label="Search"
              />

              <button *ngIf="searchval" class="clear-btn" type="button" (click)="reset()" aria-label="Clear search">✕</button>
            </div>
          </div>

          <div class="col-md-6 col-lg-5 text-right">
            <button type="button" class="btn btn-primary add-btn" (click)="openAdd()">
              <i class="fa fa-plus" aria-hidden="true"></i> Add images
            </button>
          </div>
        </div>

        <!-- Sections -->
        <h5 class="section-title">Dashboard</h5>
        <div class="row" *ngIf="showDashboard">
          <div class="col-md-3 degreeContent" *ngFor="let img of imgData">
            <p class="list-item">
              <img width="30" height="30" class="rounded-circle imgTable" [src]="img.image" /> India
              <i class="fa fa-trash-o iconEdit" aria-hidden="true" (click)="deleteImage(img)"></i>
              <i class="fa fa-pencil iconEdit" (click)="editImage(img)"></i>
            </p>
          </div>
        </div>
        <div class="noData" *ngIf="showNodashboard">
          <h2>Currently No Data Available!</h2>
        </div>

        <h5 class="section-title">Trending Courses</h5>
        <div class="row" *ngIf="showTrending">
          <div class="col-md-3 degreeContent" *ngFor="let trending of trendingCourse">
            <p class="list-item">
              <img width="30" height="30" class="rounded-circle imgTable" [src]="trending.image" /> {{ trending.country }}
              <i class="fa fa-trash-o iconEdit" aria-hidden="true" (click)="deleteImage(trending)"></i>
              <i class="fa fa-pencil iconEdit" (click)="editImage(trending)"></i>
            </p>
          </div>
        </div>
        <div class="noData" *ngIf="showNotrending">
          <h2>Currently No Data Available!</h2>
        </div>

        <h5 class="section-title">Foreign University</h5>
        <div class="row" *ngIf="showForegin">
          <div class="col-md-3 degreeContent" *ngFor="let foreign of foreignCourse">
            <p class="list-item">
              <img width="30" height="30" class="rounded-circle imgTable" [src]="foreign.image" /> {{ foreign.country }}
              <i class="fa fa-trash-o iconEdit" aria-hidden="true" (click)="deleteImage(foreign)"></i>
              <i class="fa fa-pencil iconEdit" (click)="editImage(foreign)"></i>
            </p>
          </div>
        </div>
        <div class="noData" *ngIf="showNoForeign">
          <h2>Currently No Data Available!</h2>
        </div>

        <h5 class="section-title">Material Advertisement</h5>
        <div class="row" *ngIf="showMaterial">
          <div class="col-md-3 degreeContent" *ngFor="let material of materialdata">
            <p class="list-item">
              <img width="30" height="30" class="rounded-circle imgTable" [src]="material.image" /> {{ material.country }}
              <i class="fa fa-trash-o iconEdit" aria-hidden="true" (click)="deleteImage(material)"></i>
              <i class="fa fa-pencil iconEdit" (click)="editImage(material)"></i>
            </p>
          </div>
        </div>
        <div class="noData" *ngIf="showNoMaterial">
          <h2>Currently No Data Available!</h2>
        </div>

        <!-- Add/Edit Modal -->
        <div class="backdrop" [ngStyle]="{'display':display}"></div>
        <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header" *ngIf="showAdd">
                Add Images
                <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-header" *ngIf="showEdit">
                Edit Images
                <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="dltmodal-content animate modal-body dltBl">
                <form [formGroup]="imageForm">
                  <label class="uploadImage">
                    Upload Image
                    <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                    <input type="file" formControlName="imageVal" (change)="handleFileInput($event)" multiple hidden />
                  </label>

                  <div class="mt-2">
                    <img class="multipleImg mr-2" width="80" height="80" *ngFor="let img of images" [src]="img" />
                  </div>

                  <label style="margin-top:1em;">Select Country</label>
                  <select class="form-control" [(ngModel)]="countryid" formControlName="countryName">
                    <option *ngFor="let country of countryVal; let x = index" [ngValue]="country.id">{{ country.country }}</option>
                  </select>

                  <label style="margin-top:1em;">Select College Type</label>
                  <select class="form-control" [(ngModel)]="imgTypeId" formControlName="imageTypeVal">
                    <option *ngFor="let image of imgType; let x = index" [ngValue]="image.id">{{ image.type }}</option>
                  </select>

                  <div class="addBtn" *ngIf="showAdd">
                    <button class="commonBtn mt-2" [disabled]="!imageForm.valid" (click)="addImages()">Add Image</button>
                  </div>

                  <div class="addBtn" *ngIf="showEdit">
                    <button class="commonBtn mt-2" (click)="imgUpdate()">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Delete Modal -->
        <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
        <div class="modal" id="deleteModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="dltmodal-content animate modal-body dltBl mb-3 text-center">
                <p>Do you want to delete College ?</p>
                <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%; margin-left: 0.3em;">No</button>
                <br /><br />
                <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</div>
